"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.createSomeAdAnalyticsVideoIndexWatchingRating = void 0;
const AdAnalyticsVideo_1 = require("../entity/AdAnalyticsVideo");
const createSomeAdAnalyticsVideoIndexWatchingRating = ({ until = 50, rate = 10, } = {}) => new AdAnalyticsVideo_1.AdAnalyticsVideoIndexWatchingRating({ until, rate });
exports.createSomeAdAnalyticsVideoIndexWatchingRating = createSomeAdAnalyticsVideoIndexWatchingRating;
